var clickDimensionExternalForm = {
  className: ".component .clickdform .responsiveRow",
  outerHtml: false,
  init: function init() {
    var _document$querySelect;

    this.handleLayout();
    this.handleCustomValidation();
    (_document$querySelect = document.querySelector(".component div.clickdform")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add("inited");
  },
  handleLayout: function handleLayout() {
    document.querySelectorAll(this.className).forEach(function (item) {
      var isText = item.contains(item.querySelector('input[type="text"]'));
      var isSelect = item.contains(item.querySelector("select"));
      var isTextarea = item.contains(item.querySelector("textarea"));
      var isRadio = item.contains(item.querySelector('input[type="radio"]'));
      var columns = item.querySelectorAll(".responsiveCell:not(.emptyCell)").length || 0;

      if (isText) {
        item.classList.add("text-row");
      }

      if (isSelect) {
        item.classList.add("select-row");
      }

      if (isTextarea) {
        item.classList.add("textarea-row");
      }

      if (isRadio) {
        item.classList.add("radio-row");
      }

      if (columns) {
        item.classList.add("columns-" + columns);
      }
    });
    document.querySelectorAll(this.className + ' input[type="checkbox"]').forEach(function (item) {
      var parentElement = item.parentNode;
      parentElement.classList.add("checkbox-wrapper");
      var label = document.createElement("label");
      label.innerHTML = item.nextElementSibling.innerText;
      parentElement.replaceChild(label, item.nextElementSibling);
      label.setAttribute("for", item.id);
    });
    document.querySelectorAll(this.className + ' input[type="radio"]').forEach(function (item) {
      var parentElement = item.parentNode;
      var label = document.createElement("label");
      var checkmark = document.createElement("span");
      parentElement.classList.add("radio-wrapper");
      parentElement.parentNode.classList.add("radio-container");
      checkmark.classList.add("checkmark");
      label.innerHTML = item.nextElementSibling.innerText;
      item.id = item.name + item.value;
      label.setAttribute("for", item.id);
      parentElement.replaceChild(label, item.nextElementSibling);
      label.append(checkmark);
    });
    document.querySelectorAll(this.className + ' a[href^="#"]').forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        var targetID = item.getAttribute("href").substring(1);
        var target = document.getElementById(targetID);
        var correction = document.getElementById("header").offsetHeight + 28;
        target.scrollIntoView();
        window.scrollBy(0, -correction);
      });
    });
  },
  handleCustomValidation: function handleCustomValidation() {
    var inputs = document.querySelectorAll('.component .clickdform .responsiveRow input[type="text"], .component .clickdform .responsiveRow input[type="checkbox"], .component .clickdform .responsiveRow select, .component .clickdform .responsiveRow input[type="radio"], .component .clickdform .responsiveRow textarea:not(#g-recaptcha-response)');
    var submitBtn = document.getElementById("btnSubmit");

    function checkIfRequired(item) {
      return item.getAttribute("aria-required") === "true";
    }

    function validateEmail(item) {
      if (item.classList.contains("EmailComponent")) {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailIsInvalid = !emailRegex.test(item.value) && item.value.length > 0;
        var emails = document.querySelectorAll('.component .clickdform .responsiveRow input[type="text"].EmailComponent');

        if (emails.length > 1) {
          var emailsDoNotMatch = emails[0].value.trim() !== emails[1].value.trim();
          return emailsDoNotMatch || emailIsInvalid;
        }

        return emailIsInvalid;
      }
    }

    function validateCustomRegex(item) {
      var hasCustomRegex = item.parentElement.parentElement.parentElement.querySelector("[customregex]").getAttribute("customregex").slice(1, -1);

      if (hasCustomRegex.length > 0) {
        var formatedRegex = new RegExp(hasCustomRegex);
        return !formatedRegex.test(item.value);
      }
    }

    function validate(item) {
      var conditionsForRequired = {
        textinput: item.getAttribute("type") === "text" && checkIfRequired(item) && item.value.length < 1,
        select: checkIfRequired(item) && item.value < 0,
        checkbox: item.getAttribute("type") === "checkbox" && !item.checked && checkIfRequired(item),
        textarea: item.nodeName.toLowerCase() === "textarea" && checkIfRequired(item) && item.value.length < 1,
        radio: item.getAttribute("type") === "radio" && !item.parentElement.parentElement.querySelector('input[type="radio"]:checked') && checkIfRequired(item)
      };
      var conditionsForInvalid = {
        email: validateEmail(item),
        customRegex: validateCustomRegex(item)
      };
      var isRequiredAndEmpty = Object.values(conditionsForRequired).includes(true);
      var isInvalid = Object.values(conditionsForInvalid).includes(true);
      var container = item.parentElement.parentElement.parentElement;
      var validationContainer = container.querySelector(".requiredInfo");

      function addErrorMessage(validationText) {
        validationContainer.innerText = validationText;
        container.classList.add("error");
      }

      if (isRequiredAndEmpty) {
        var requiredErrorMessage = container.querySelector("[requrederrormsg]").getAttribute("requrederrormsg");
        addErrorMessage(requiredErrorMessage);
      } else if (isInvalid) {
        var invalidErrorMessage = container.querySelector("[errormsg]").getAttribute("errormsg");
        addErrorMessage(invalidErrorMessage);
      } else {
        container.classList.remove("error");
      }
    }

    function validateCaptcha() {
      var captcha = document.getElementById("gcaptcha");
      if (!captcha) return;

      if (grecaptcha && grecaptcha.getResponse().length === 0) {
        captcha.parentElement.parentElement.classList.add("error");
      } else {
        captcha.parentElement.parentElement.classList.remove("error");
      }
    }

    function handleInputsOnBlur() {
      inputs.forEach(function (item) {
        item.addEventListener("blur", function () {
          validate(item);
        });
      });
    }

    function scrollToFirstError() {
      var error = document.querySelectorAll(".clickdform .error")[0];
      error.scrollIntoView();
      window.scrollBy(0, -60);
    }

    function handleOnSubmit() {
      inputs.forEach(function (item) {
        validate(item);
      });
      validateCaptcha();
      var isFormValid = document.querySelectorAll(".clickdform .error").length < 1;

      if (isFormValid) {
        submitBtn.click();
      } else {
        scrollToFirstError();
      }
    }

    function handleSubmitButton() {
      var newElement = submitBtn.cloneNode(true);
      newElement.setAttribute("onclick", null);
      newElement.classList.add("fake-button");
      newElement.id = "fakeBtnSubmit";
      submitBtn.parentElement.appendChild(newElement);
      submitBtn.style.display = "none";
      document.querySelector(".buttonContainer .fake-button").addEventListener("click", handleOnSubmit, false);
    }

    handleInputsOnBlur();
    handleSubmitButton();
  }
};
window.clickDimensionExternalForm = clickDimensionExternalForm;

window.onload = function onLoad() {
  clickDimensionExternalForm.init();
};